var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widM pf23-inFo-safe-wrap pf23-lineBtm" }, [
    _c("p", { staticClass: "fntP padTSM" }, [
      _vm._v(_vm._s(_vm.title)),
      _vm.isRequired ? _c("span", { staticClass: "ico-must-astar" }) : _vm._e()
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "fntP padTSM" }, [_vm._v(_vm._s(_vm.description))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "clearfix marTSM" },
      [
        _vm._l(_vm.mainResponses, function(participant, idx) {
          return [
            _c(
              "div",
              {
                key: "participant-" + _vm.sqCode + "-" + idx,
                class: { "floL pcOnly": idx == 0, floR: idx != 0 }
              },
              [
                _vm.sqCode === "Q119"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "pf23-inFo-safe",
                          attrs: { id: "Q119-" + idx }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "amway-theme",
                              staticStyle: { width: "55%" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "amw-radio-wrap radio-label focus"
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "amw-global-radio",
                                        attrs: {
                                          type: "radio",
                                          name: "safety-radio-" + idx,
                                          value: "Y",
                                          disabled:
                                            !participant.attendance_yn ||
                                            participant.attendance_yn === "N" ||
                                            !_vm.infoAvailable
                                        },
                                        domProps: {
                                          checked:
                                            participant.questions[_vm.sqCode]
                                              .raw_data === "Y"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.inputRadioAnswer(
                                              "" + idx,
                                              _vm.sqCode,
                                              "Y"
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "amw-radio-overlay"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "amw-label-radio-text" },
                                        [_vm._v("예")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "amw-radio-wrap radio-label focus"
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "amw-global-radio",
                                        attrs: {
                                          type: "radio",
                                          name: "safety-radio-" + idx,
                                          value: "N",
                                          disabled:
                                            !participant.attendance_yn ||
                                            participant.attendance_yn === "N" ||
                                            !_vm.infoAvailable
                                        },
                                        domProps: {
                                          checked:
                                            participant.questions[_vm.sqCode]
                                              .raw_data === "N"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.inputRadioAnswer(
                                              "" + idx,
                                              _vm.sqCode,
                                              "N"
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "amw-radio-overlay"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "amw-label-radio-text" },
                                        [_vm._v("아니오")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.sqCode === "Q120"
                  ? [
                      _c("div", { staticClass: "pf23-ipE" }, [
                        _c(
                          "label",
                          {
                            staticClass: "fntP",
                            staticStyle: { display: "none" },
                            attrs: { for: "NCAcmi_allergy01-" + idx }
                          },
                          [_vm._v("답변")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "widM ip-Max",
                          class:
                            _vm.isRequired &&
                            participant.questions[_vm.sqCode].hasError
                              ? "check-red"
                              : "",
                          attrs: {
                            type: "text",
                            maxlength: "30",
                            id: "Q120-" + idx,
                            name: "NCAcmi_allergy01-" + idx,
                            disabled:
                              !participant.attendance_yn ||
                              participant.attendance_yn === "N" ||
                              !_vm.infoAvailable
                          },
                          domProps: {
                            value: participant.questions[_vm.sqCode].raw_data
                          },
                          on: {
                            input: function($event) {
                              return _vm.inputAnyAnswer(
                                idx,
                                _vm.sqCode,
                                $event.target
                              )
                            }
                          }
                        })
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.sqCode === "Q121"
                  ? [
                      _c(
                        "div",
                        {},
                        [
                          _c("div", { staticClass: "pf23-ipE" }, [
                            _c(
                              "label",
                              {
                                staticClass: "fntP",
                                staticStyle: { display: "none" },
                                attrs: { for: "Q121-" + idx }
                              },
                              [_vm._v("답변")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "pf23-inFo-safe" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "amway-theme",
                                  staticStyle: { width: "55%" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "amw-radio-wrap radio-label focus"
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "amw-global-radio",
                                            attrs: {
                                              type: "radio",
                                              id: "Q121-" + idx,
                                              name: "visa-eta-radio-" + idx,
                                              value: "Y",
                                              disabled:
                                                !participant.attendance_yn ||
                                                participant.attendance_yn ===
                                                  "N" ||
                                                !_vm.infoAvailable
                                            },
                                            domProps: {
                                              checked:
                                                participant.questions[
                                                  _vm.sqCode
                                                ].raw_data === "Y"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputVisaEtaAnswer(
                                                  "" + idx,
                                                  _vm.sqCode,
                                                  "Y"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "amw-radio-overlay"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "amw-label-radio-text"
                                            },
                                            [_vm._v("예")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "amw-radio-wrap radio-label focus"
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "amw-global-radio",
                                            attrs: {
                                              type: "radio",
                                              name: "visa-eta-radio-" + idx,
                                              value: "Y",
                                              disabled:
                                                !participant.attendance_yn ||
                                                participant.attendance_yn ===
                                                  "N" ||
                                                !_vm.infoAvailable
                                            },
                                            domProps: {
                                              checked:
                                                participant.questions[
                                                  _vm.sqCode
                                                ].raw_data === "N"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.inputVisaEtaAnswer(
                                                  "" + idx,
                                                  _vm.sqCode,
                                                  "N"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "amw-radio-overlay"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "amw-label-radio-text"
                                            },
                                            [_vm._v("아니오")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          participant.questions[_vm.sqCode].raw_data == "Y"
                            ? [
                                participant.questions[_vm.sqCode].raw_data ==
                                "Y"
                                  ? _c(
                                      "div",
                                      { staticClass: "pf23-visa-wrap inFo-L" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pf23-inFo-L padBSM padTSM pf23-inFo-common"
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "fntP",
                                                attrs: { for: "Q122-" + idx }
                                              },
                                              [
                                                _vm._v("비자 번호"),
                                                _c("span", {
                                                  staticClass: "ico-must-astar"
                                                }),
                                                _c("br"),
                                                _vm._v(
                                                  "(Visa Grant Number)\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              class:
                                                _vm.isRequired &&
                                                participant.questions["Q122"]
                                                  .hasError &&
                                                  participant.questions["Q122"]
                                                    .raw_data
                                                  ? "check-red"
                                                  : "",
                                              attrs: {
                                                type: "text",
                                                maxlength: "13",
                                                id: "Q122-" + idx,
                                                name: "pf23visNum01-" + idx,
                                                disabled:
                                                  !participant.attendance_yn ||
                                                  participant.attendance_yn ===
                                                    "N" ||
                                                  !_vm.infoAvailable
                                              },
                                              domProps: {
                                                value:
                                                  participant.questions["Q122"]
                                                    .raw_data
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.inputVisaNumberAnswer(
                                                    idx,
                                                    "Q122",
                                                    $event.target
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.isRequired &&
                                        participant.questions["Q122"]
                                          .hasError &&
                                          participant.questions["Q122"].raw_data
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "marTS fntE padBSM",
                                                staticStyle: {
                                                  color: "#d91734",
                                                  "text-indent": "-0.6em",
                                                  "padding-left": "0.6em"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "🚫  Visa 번호 13자리를 모두 입력해주세요."
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        participant.questions[_vm.sqCode]
                                          .raw_data == "Y"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pf23-inFo-L padBSM padTSM pf23-inFo-common"
                                              },
                                              [
                                                _vm._m(0, true),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pf23-inFo-select pf23-date"
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass: "NCAcmi_num",
                                                      class:
                                                        _vm.ishint &&
                                                        participant.questions[
                                                          "Q123"
                                                        ].hasError
                                                          ? "check-red"
                                                          : "",
                                                      staticStyle: {
                                                        width: "100%"
                                                      },
                                                      attrs: {
                                                        type: "date",
                                                        id: "Q123" + idx,
                                                        name:
                                                          "NCAcmi_visa_expired_date" +
                                                          idx,
                                                        size: "50",
                                                        maxlength: "50",
                                                        disabled:
                                                          !participant.attendance_yn ||
                                                          participant.attendance_yn ===
                                                            "N" ||
                                                          !_vm.infoAvailable,
                                                        min: _vm.today
                                                      },
                                                      domProps: {
                                                        value:
                                                          participant.questions[
                                                            "Q123"
                                                          ].raw_data
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputVisaEtaDateAnswer(
                                                            idx,
                                                            "Q123",
                                                            $event.target
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "marTS fntE",
                                            staticStyle: {
                                              color: "#d91734",
                                              "text-indent": "-0.6em",
                                              "padding-left": "0.6em"
                                            }
                                          },
                                          [
                                            _vm.isRequired &&
                                            _vm.ishint &&
                                            participant.questions["Q123"]
                                              .hasError
                                              ? [
                                                  _vm._v(
                                                    "🚫 " +
                                                      _vm._s(
                                                        participant.questions[
                                                          "Q123"
                                                        ].remarks
                                                          ? participant
                                                              .questions["Q123"]
                                                              .remarks
                                                          : "비자유효기간을 선택해 주세요."
                                                      )
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "marTS fntE padBSM",
                                    staticStyle: {
                                      color: "#d91734",
                                      "text-indent": "-0.6em",
                                      "padding-left": "0.6em"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "* AustrailanETA앱의 Visa Status > Visa details에서 확인 가능합니다."
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(1, true)
                        ],
                        2
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.tooltip
      ? _c(
          "p",
          {
            staticClass: "marTS fntE padBSM",
            staticStyle: {
              color: "#d91734",
              "text-indent": "-0.6em",
              "padding-left": "0.6em"
            }
          },
          [_vm._v(_vm._s(_vm.tooltipMessage))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("비자 유효기간 "),
      _c("span", { staticClass: "ico-must-astar" }),
      _c("br"),
      _vm._v("(Visa Expiry Date)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "marTS fntP padBSM" }, [
      _c(
        "a",
        {
          staticStyle: { color: "#0075a4", "font-weight": "500" },
          attrs: {
            href:
              "https://www.youtube.com/watch?v=wFp2yij2uUA&ab_channel=호뚜루뉴뚜루",
            target: "_blank"
          }
        },
        [_vm._v("* "), _c("u", [_vm._v("ETA 신청방법 확인하기 >")])]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d41acbfe", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d41acbfe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sydney/components/SurveyParticipantFloat.vue
// module id = null
// module chunks = 